import { render, staticRenderFns } from "./SepMemberCallback.vue?vue&type=template&id=4520bf12&scoped=true"
import script from "./SepMemberCallback.vue?vue&type=script&lang=js"
export * from "./SepMemberCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520bf12",
  null
  
)

export default component.exports